import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

export default Wrapper(styled.div`
${({ displayState }) => css`
    width: 33%; display: flex; align-items: center; justify-content: ${displayState?.justifyContent ?? 'center'};
  `}
`);